export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#/,\-_;:|<>])[A-Za-z\d@$!%*?&.#/,\-_;:|<>]{6,}$/;
export const senderBusinessNameRegex = /^[a-zA-Z0-9]{1,11}$/;
export const alphaNumericRegex = /[a-zA-Z0-9]/g;
export const nonAlphaNumericRegex = /[^a-zA-Z0-9]/g;
export const businessNameRegex = /[A-Za-z0-9_-\s]+$/;

export const firstOrLastNameRegex = /^(?=.{1,50}$)[a-z]+(?:['_.\s][a-z]+)*$/i;
